var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.TButton,{attrs:{"type":"button","icon":"/images/icons/google.svg"},on:{"click":function($event){$event.preventDefault();return _setup.getGoogleCode.apply(null, arguments)}}},[_vm._v("\n  Google\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }